module.exports = __webpack_public_path__ + "img/40_37_026_060.e670a001.jpg";